import moment from "moment"; // Ensure moment is imported

// Fixed type of input parameters
export const date_diff_indays = function (date1: Date, date2: Date): number {
  const dt1 = new Date(date1);
  const dt2 = new Date(date2);
  return Math.floor(
    (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
      Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
      (1000 * 60 * 60 * 24)
  );
};

export const todayIso = function (): string {
  return new Date().toISOString().split("T")[0];
};

const tConst = { START_TIME: 8 }; // Define tConst with START_TIME property

export function getTimelineQuarter(calendarQuarterStartDate: Date): Date {
  const _start = new Date(2020, 0, 9, tConst.START_TIME);

  const _diff =
    (calendarQuarterStartDate.getTime() -
      new Date(2020, 0, 9, 0, 0, 0, 0).getTime()) /
    (1000 * 60 * 60 * 24);
  const _remainingDays = 14 - (_diff % 14);

  _start.setDate(_start.getDate() + (_diff + _remainingDays));

  return _start;
}

export function findNextQuarterStart(date: Date): Date {
  const _endOfCalendarQuarter = moment(date).endOf("quarter").toDate();
  const _nextQuarterStart = getTimelineQuarter(_endOfCalendarQuarter);
  return _nextQuarterStart;
}

export function findPrevQuarterStart(date: Date): Date {
  const _startOfCalendarQuarter = moment(date).startOf("quarter").toDate();
  // Subtract one day
  const _dayBeforeStartOfCalendarQuarter = new Date(
    _startOfCalendarQuarter.getTime() - 1 * 24 * 60 * 60 * 1000
  );
  // Find the beginning of the previous quarter
  const _startOfPrevCalQuarter = moment(_dayBeforeStartOfCalendarQuarter)
    .startOf("quarter")
    .toDate();

  const _startOfPrevQuarter = getTimelineQuarter(_startOfPrevCalQuarter);

  return _startOfPrevQuarter;
}
